import { getDoc, getDropdownList } from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export const fetchPaymentTransactionById = (app, params) => {
  const { id } = params;
  return getDoc(app, { id, docType: DocType.PAYMENT });
}

export const fetchPaymentDropdown = (app, params) => {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'payment/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return getDropdownList(app, { query });
}
